import React from 'react';
import { Route, Switch } from 'react-router-dom';

import { siteUrlsSelector } from '~src/bootstrap/redux/selectors/SiteUrlsSelectors';
import { getAppStore } from '~src/bootstrap/redux/store/AppStore';
import { SessionManagementService } from '~src/sessionManagement/SessionManagementService';
import { ServerSettings, ServerSettingsInstance } from '~src/settings/services/ServerSettings';
import { Sites } from '~src/siteManagement/services/resources/Sites';
import { SpacesSiteUrls } from '~src/spacesPlatform/components/spaceComponents/SpacesSiteUrls';

import { AuthenticationSiteSettingsSubspace } from '../../components/subspaces/SiteSettingsSpace/AuthenticationSettingsSubspace';
import { AuthenticationConfigurationSpace } from './AuthenticationConfigurationSpace';
import { ScimConfigurationSpace } from './ScimConfigurationSpace';

export interface AuthenticationSubspaceRouterProps {
  readonly serverSettingsService: ServerSettings;
  readonly sites: Sites;
  readonly siteName: string;
  readonly urls: SpacesSiteUrls;
  readonly server: SessionManagementService;
  readonly isSessionServerAdmin: boolean;
}

export function AuthenticationSubspaceRouter(props: AuthenticationSubspaceRouterProps) {
  const siteUrls = siteUrlsSelector(getAppStore().getState());
  return <Switch>
    <Route exact path={siteUrls.settingsAuthenticationPath()} render={({ match }) => {
      return <AuthenticationSiteSettingsSubspace siteName={props.siteName}
        urls={props.urls}
        server={props.server}
        isSessionServerAdmin={props.isSessionServerAdmin}
        serverSettingsService={ServerSettingsInstance}
        sites={Sites.instance} {...match} />;
    }} />
    <Route exact path={siteUrls.authenticationEditConfigurationPath(':config')} render={({ match }) => {
      return <AuthenticationConfigurationSpace isNewConfigPage={ false } {...match}/>;
    }} />
   <Route exact path={siteUrls.authenticationNewConfigurationPath()} render={({match}) => {
      return <AuthenticationConfigurationSpace isNewConfigPage={true} {...match}/>;
    }} />
   <Route exact path={siteUrls.scimNewConfigurationPath()} render={({ match }) => {
      return <ScimConfigurationSpace isNewConfigPage={true} urls={props.urls} {...match} />;
    }} />
       <Route exact path={siteUrls.scimEditConfigurationPath(':config')} render={({ match }) => {
      return <ScimConfigurationSpace isNewConfigPage={false} urls={props.urls} {...match} />;
    }} />
  </Switch>;
}
